import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { QuarterlyFeedback } from '@app/shared/interfaces/quarterly-feedback.model';
import { GlobalErrorService } from '@app/shared/services/global-error.service';
import { environment } from '@environments/environment';
import { catchError, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class QuarterlyFeedbackFormService {
  private baseUrl = environment.apiUrl;
  constructor(
    private http: HttpClient,
    private errorHandler: GlobalErrorService,
  ) {}

  saveFeedbackFormData(feedbackData: any): Observable<QuarterlyFeedback> {
    return this.http
      .post<QuarterlyFeedback>(
        `${this.baseUrl}/ops/quarterly-feedback/compliance`,
        feedbackData,
      )
      .pipe(
        catchError((error) => {
          return this.errorHandler.logError(error);
        }),
      );
  }
}
